<template>
  <v-container
    id="detalhe-melhores-clientes-form"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <v-row>
          <v-col
            cols="12"
            class="container"
          >
            <v-container>
              <dashboard-filtro-datas
                :primeiro="enablePrimeiroDia"
                :ultimo="enableUltimoDia"
                :empresas="enableEmpresa"
                :vendedores="enableVendedor"
                :supervisores="enableSupervisor"
                :areas="enableArea"
                :redes="enableRede"
                :receitas="enableReceita"
                :segmentos="enableSegmento"
              />
            </v-container>
            <v-row>
              <v-col
                cols="12"
                sm="12"
                md="12"
                lg="12"
              >
                <div>
                  <v-row>
                    <v-col
                      cols="12"
                      sm="12"
                      md="12"
                      lg="12"
                    >
                      <v-card
                        id="cardDashbord"
                        class="mx-auto"
                        outlined
                      >
                        <div class="card-header-dashbord">
                          <v-row>
                            <v-col
                              cols="12"
                              sm="9"
                              md="9"
                              lg="9"
                              class="d-flex flex-wrap"
                            >
                              Quais produtos vender
                            </v-col>
                            <v-col
                              cols="12"
                              sm="1"
                              md="1"
                              lg="1"
                              class="d-flex justify-end"
                            >
                              <v-btn
                                id="btnPrint"
                                class="col-12 lg-12"
                                small
                                :color="corPrimaria"
                                dark
                                :disabled="enableBtn"
                                :loading="imprimindo"
                                @click="imprimir()"
                              >
                                <v-icon>
                                  mdi-printer
                                </v-icon>
                                Imprimir
                                <template v-slot:loader>
                                  <span>Imprimindo...</span>
                                </template>
                              </v-btn>
                            </v-col>
                            <v-col
                              cols="12"
                              sm="2"
                              md="2"
                              lg="2"
                              class="d-flex justify-end"
                            >
                              <v-tooltip
                                top
                                max-width="400"
                                width="400"
                              >
                                <template
                                  v-slot:activator="{ on, attrs }"
                                >
                                  <v-icon
                                    id="iconInformationMelhoresClientes"
                                    class="text-left"
                                    v-bind="attrs"
                                    v-on="on"
                                    @mouseover="enableTexto('333')"
                                  >
                                    mdi-information-outline
                                  </v-icon>
                                </template>
                                <div
                                  v-if="!carregandoTooltip"
                                  v-html="textoOrientacao"
                                />
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </div>
                        <v-card-actions>
                          <v-row>
                            <v-col
                              cols="12"
                              sm="12"
                              md="12"
                              lg="12"
                            >
                              <div
                                v-if="loading"
                                :style="styleObject"
                                class="text-center"
                              >
                                <v-icon
                                  light
                                  class="custom-loader"
                                  :style="styleObject"
                                >
                                  mdi-cached
                                </v-icon>
                                Carregando dados...
                              </div>
                              <div
                                v-else-if="error"
                                class="alert alert-danger"
                              >
                                {{ error }}
                              </div>
                              <div v-else>
                                <div
                                  id="idTable"
                                  style="overflow-x: auto; max-width: 100%;"
                                >
                                  <table
                                    style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
                                    class="elevation-1"
                                  >
                                    <thead>
                                      <tr>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Classificação produto
                                        </th>
                                        <th
                                          id="dadoMovimentacaoHeader"
                                          style="text-align: center;"
                                          class="black--text title"
                                        >
                                          Status
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr
                                        v-for="item in dadosDetalhamento"
                                        :key="item.id"
                                      >
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: center;"
                                        >
                                          {{ item.grupo_produto }}
                                        </td>
                                        <td
                                          id="dadoMovimentacao"
                                          style="text-align: center;"
                                        >
                                          {{ item.status }}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import eventEmit from '../../../components/core/EventoEmit'
  import Cliente from '../../../../../services/somentecliente'
  import Permissao from '../../../../../services/menu'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'

  export default {
    name: 'DashboardExtratoClienteMixComercializadoDetalhamento',
    emits: ['atualizarTexto'],
    components: {
      DashboardCoreSnackbar: () => import('../../../components/core/Snackbar'),
      DashboardFiltroDatas: () => import('../../../components/core/FiltroDatas'),
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      appOnline: navigator.onLine,
      corPrimaria: localStorage.corPrimaria,
      corSecondaria: localStorage.corSecondaria,
      styleObjectIcon: {
        color: '#4780b8',
      },
      valorReceber: localStorage.valorReceber,
      valorVencido: 0,
      paginaEnable: false,
      permissaoContasReceber: '',
      primeiroDia: (new Date(localStorage.dataInicial)).toISOString().substr(0, 10),
      ultimoDia: (new Date(localStorage.dataFinal)).toISOString().substr(0, 10),
      enableEmpresa: true,
      enableVendedor: true,
      enableSupervisor: true,
      enableArea: true,
      enableRede: true,
      enableReceita: true,
      enableSegmento: true,
      select: [],
      vendedorSelect: [],
      areaSelect: [],
      redeSelect: [],
      supervisorSelect: [],
      receitaIds: [],
      segmento: [],
      selectCategoria: [],
      selectPromotor: [],
      selectClassificacao: [],
      selectCliente: JSON.parse(localStorage.getItem('clienteSelect')),
      enablePrimeiroDia: true,
      enableUltimoDia: true,
      link: localStorage.linkClientes,
      menu: false,
      menu1: false,
      dataInicialImpressao: false,
      dataFinalImpressao: false,
      codigo: 0,
      orientacao: [],
      textoDetalhesClientePordutosVender: '',
      headersProdutosVender: [
        { text: 'Classificação produto', value: 'grupo_produto', width: '200', class: 'black--text title' },
        { text: 'Status', value: 'status', width: '120px', class: 'black--text title' },
      ],
      dadosDetalhamento: [],
      snackbar: {
        visible: false,
        color: 'success',
        direction: 'top center',
        message: 'My timeout is set to 3000.',
        timeout: 3000,
      },
      enableBtn: true,
      loading: false,
      error: null,
      enableTable: false,
      imprimindo: false,
      textoOrientacao: '',
      carregandoTooltip: false,
      codigoAtual: null,
    }),

    computed: {
      computedDateFormatted () {
        return this.formatDate(this.ultimoDia)
      },

      computedPrimeiroDia () {
        return this.formatDatePrimeiroDia(this.primeiroDia)
      },

      likesAllCliente () {
        return this.selectCliente.length === this.clientes.length
      },
      likesSomeCliente () {
        return this.selectCliente.length > 0 && !this.likesAllCliente
      },
      icon () {
        if (this.likesAllCliente) return 'mdi-close-box'
        if (this.likesSomeCliente) return 'mdi-minus-box'
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.enableConsulta = false
        return 'mdi-checkbox-blank-outline'
      },
    },

    created () {
      eventEmit.$on('update-dados', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados', this.handleUpdateDados)
    },

    mounted () {
      if (localStorage.tokencontrato) {
        this.usuarioIdentificado = true

        Cliente.showDadosCliente(localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status) {
            for (var i = 0; i < resposta.data.dadosClientes.length; i++) {
              this.clientes.push(resposta.data.dadosClientes[i])
            }
          } else if (resposta.data.msg === 'Não há clientes cadastrados') {
            this.clientes = []

            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })

        eventEmit.$emit('atualizar_texto', 'Cliente')
      } else {
        this.usuarioIdentificado = false
        localStorage.removeItem('username')
        localStorage.removeItem('email')
        localStorage.removeItem('nome')
        localStorage.removeItem('usuarioIdentificado')
        this.$router.push('/login')
      }
    },

    methods: {
      toggle () {
        this.$nextTick(() => {
          if (this.likesAllCliente) {
            this.selectCliente = []
          } else {
            if (this.filterClientes.length > 0) {
              this.selectCliente = this.filterClientes
            } else {
              this.selectCliente = this.clientes.slice()
            }
          }
        })
      },

      filter () {
        if (this.filtro.length > 0) {
          for (let i = 0; i < this.clientes.length; i++) {
            if (this.clientes[i].cliente.toLowerCase().includes(this.filtro.toLowerCase())) {
              this.filterClientes.push(this.clientes[i])
            }
          }
        } else {
          this.filterClientes = []
        }
      },

      formatDate (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      formatDatePrimeiroDia (date) {
        if (!date) {
          return null
        }

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      parseDate (date) {
        if (!date) return null

        const [month, day, year] = date.split('/')
        return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
      },

      async enableTexto (value) {
        if (this.codigoAtual === value && this.textoOrientacao) return

        this.codigoAtual = value
        this.carregandoTooltip = true
        this.textoOrientacao = ''

        try {
          const resposta = await Permissao.showOrientacaoIndicador(localStorage.username, localStorage.tokencontrato, value)

          if (resposta.data.status) {
            this.textoOrientacao = resposta.data.orientacao
            this.codigo = value
          }
        } catch (e) {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        } finally {
          this.carregandoTooltip = false
        }
      },

      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedorSelect = vendedor
        this.areaSelect = area
        this.redeSelect = rede
        this.supervisorSelect = supervisor
        this.receita = receita
        this.segmento = segmento

        localStorage.setItem('updateDadosFiltros', true)
        localStorage.setItem('dataInicial', this.primeiroDia)
        localStorage.setItem('dataFinal', this.ultimoDia)
        localStorage.setItem('empresaId', JSON.stringify(this.select || []))

        this.updateDate()
      },

      updateDate () {
        this.dadosDetalhamento = []

        this.formatarDatasImpressao()

        this.enableTable = false

        this.showDelhamentoExtratoSomenteClienteProdutosVender()
      },

      async imprimir () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          // Função para adicionar tabela e controlar quebra de página
          const addTable = async (data, headers, title, posY, fontSize) => {
            pdf.text(title, 15, posY)
            posY += pdf.getTextDimensions(title).h

            pdf.autoTable({
              head: [headers.map(header => ({ content: header.text, styles: { fontSize: fontSize, textColor: [0, 0, 0] } }))],
              body: data.map(row => row.map(cell => ({ content: cell, styles: { fontSize: 8, textColor: [0, 0, 0] } }))),
              startY: posY,
              styles: { fontSize: fontSize },
            })

            posY = 20

            return posY
          }

          let posYFiltros = 10

          const title = 'Filtros selecionados'
          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia
          posYFiltros += 10
          pdf.setFontSize(10)
          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cliente(s) Selecionado(s):', this.selectCliente.map(e => e.cliente))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedorSelect.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.areaSelect.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.redeSelect.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisorSelect.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Receita(s) Selecionada(s):', this.receitaSelect.map(re => re.nome))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.selectSegmento.map(se => se.segmento))

          if (posYFiltros > 70) {
            pdf.addPage()

            posYFiltros = 10
          }

          const titleTable = 'Qual o perfil do MIX comprado?'
          const table = this.dadosDetalhamento.map(item => [item.grupo_produto, item.status])
          posYFiltros = await addTable(table, this.headersProdutosVender, titleTable, posYFiltros, 8)

          pdf.save('relatorio_detalhe_melhores_clienes.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      formatarDatasImpressao () {
        var partesInicial = this.primeiroDia.split('-')
        var ano = partesInicial[0]
        var mes = partesInicial[1]
        var dia = partesInicial[2]
        this.dataInicialImpressao = dia + '/' + mes + '/' + ano

        var partesFinal = this.ultimoDia.split('-')
        var anoFinal = partesFinal[0]
        var mesFinal = partesFinal[1]
        var diaFinal = partesFinal[2]
        this.dataFinalImpressao = diaFinal + '/' + mesFinal + '/' + anoFinal
      },

      showDelhamentoExtratoSomenteClienteProdutosVender () {
        this.loading = true
        this.enableBtn = true

        if (localStorage.tokencontrato === 'b8980aa4-5f2f-4bf0-aec3-a06af413dec6' || localStorage.tokencontrato === 'c1975b3b-85fd-4cbe-9c56-df82c284fb40') {
          this.enableTable = true

          this.headersProdutosVender = [
            { text: 'Linha de produto', value: 'grupo_produto', width: '200', class: 'black--text title' },
            { text: 'Status', value: 'status', width: '120px', class: 'black--text title' },
          ]

          Cliente.showClientesProdutoVenderEFocar(this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, this.vendedorSelect, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receita, this.segmento).then(resposta => {
            if (resposta.data.status) {
              this.enableBtn = false

              this.dadosDetalhamento = resposta.data.produtosVender
            } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.error = e.message
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => {
            this.loading = false
          })
        } else {
          this.enableTable = true

          Cliente.showClientesProdutoVenderEFocarClassificacao(this.primeiroDia, this.ultimoDia, this.select, this.selectCliente, this.vendedorSelect, localStorage.tokencontrato, this.areaSelect, this.redeSelect, this.supervisorSelect, this.receitaSelect, this.selectSegmento, [], []).then(resposta => {
            if (resposta.data.status) {
              this.enableBtn = false

              this.dadosDetalhamento = resposta.data.produtosVender
            } else if (resposta.data.msg === 'Não há dados para o período selecionado') {
              this.dadosDetalhamento = []

              this.showSnackbar('error', 3000, resposta.data.msg)
            }
          }).catch(e => {
            if (e.message === 'Network Error') {
              this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
            }
          }).finally(f => {
            this.loading = false
          })
        }
      },

      getColor (value) {
        var porcentagem = parseFloat(value.replace(',', '.'))

        if (porcentagem >= 100) {
          return 'color: green'
        } else {
          return 'color: red'
        }
      },
    },
  }
</script>
<style lang="sass">
  .no-list-style
    list-style-type: none
    padding: 0
    margin: 0

  .no-list-style li
    text-decoration: none

  .hidden
    display: none

  #relatorioMelhoresClientesFaturados
    margin-left: 0.5rem
    font-size: 14px
    font-weight: bold

  #iconInformationMelhoresClientes
    margin-left: 9.5rem
    font-weight: bold

  #headersClientesFaturados
    margin-left: 1.7rem
    margin-right: 1.7rem

  .custom-loader
    animation: loader 1s infinite
    display: flex
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

</style>

<style scoped>
  #cardDashbord {
    border-radius: 14px;
    border: 1px solid rgba(0,0,0,0.05);
    box-shadow:
      0 2px 4px rgba(0,0,0,0.08),
      0 6px 12px rgba(0,0,0,0.06),
      0 12px 24px rgba(0,0,0,0.04);
    transition: all 0.25s ease;
    transform: translateY(-3px);
    box-shadow:
      0 4px 8px rgba(0,0,0,0.10),
      0 12px 22px rgba(0,0,0,0.09),
      0 20px 32px rgba(0,0,0,0.06);
  }

  .card-header-dashbord {
    background-color: #ffffff;
    padding: 14px 18px;
    font-weight: 600;
    font-size: 14px;
    color: black;
    border-bottom: 1px solid #b7b1b1;
    border-radius: 14px 14px 0 0;
  }

  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #idTable {
      max-height: 500px;
    }

    #dadoMovimentacao {
      font-size: 8.5px !important;
    }

    th, td {
      padding: 8px;
    }
  }

  @media screen
  and (min-width : 681)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width : 1001px)
  and (max-width : 1280px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width : 1601px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }
</style>
